module.exports = __webpack_public_path__ + "static/media/unknown_user.8e71848b.png";